import { ContentPanel } from '@hopskipdrive/react-components';
import { colorPalette, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const RideOverviewItemContainer = styled(ContentPanel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid ${colorPalette.neutralVariant90};
  border-radius: 0;

  .value {
    font-size: 18px;
  }
  .driver {
    font-size: 15px;
    text-align: center;
  }

  ${variables.mediaQuery.lessThan('desktop')`   
      border: none;
      flex-direction: row-reverse;
      justify-content: space-between;

      .value {
        margin-right: 64px;
        width: 30%;
      }
  `}
`;
